export const NOVIDADES_COUNT = "NOVIDADES_COUNT";
export const NOVIDADES_LIST = "NOVIDADES_LIST";
export const NOVIDADES_LOAD = "NOVIDADES_LOAD";
export const NOVIDADES_PAGE_SIZE = 20;
